import { Component, OnInit } from '@angular/core';
import { ButtonEventsService } from '../../services/button-events.service';
import { CmxLayoutService } from '../../services/cmx-layout.service';

@Component({
  selector: 'cmx-mobile-lang-selector',
  templateUrl: './cmx-mobile-lang-selector.component.html',
  styleUrls: ['./cmx-mobile-lang-selector.component.scss'],
})
export class CmxMobileLangSelectorComponent implements OnInit {
  selectedLangId: number;

  constructor(
    public buttons: ButtonEventsService,
    public layout: CmxLayoutService,
  ) {}

  ngOnInit() {
    this.selectedLangId = this.layout.activeLanguageId.getValue();
  }

  selectLang(id: number) {
    this.selectedLangId = id;
  }

  cancel() {
    this.layout.isMobileLangSelectorOpen.next(false);
  }

  apply() {
    this.layout.languageChange.next(this.selectedLangId);
    this.layout.isMobileLangSelectorOpen.next(false);
  }
}
